module.exports = __webpack_public_path__ + "ml.c931aaa1.svg";